export const ASSIGNABLE_ROLES = [
  { key: 'CLINIC_ADMIN', label: 'Administrador da Clínica' },
  { key: 'DENTIST', label: 'Dentista' },
  { key: 'FINANCIAL', label: 'Financeiro' },
  { key: 'RECEPTIONIST', label: 'Recepcionista' },
];

export const roleLabel = (roleKey) =>
  ASSIGNABLE_ROLES.find((role) => role.key === roleKey)?.label ?? roleKey;

export const BASE_ACCESS = [
  'Início',
  'Agenda',
  'Consultas (confirmação)',
  'Pacientes',
  'Cadastros',
  'Gerar cobrança e receber tratamentos dos pacientes',
  'Suporte',
  'Alterar senha e Termos',
];

// Observação sobre o limite financeiro das telas base.
export const BASE_ACCESS_NOTE =
  'Não é possível gerar outras entradas/saídas financeiras — apenas cobranças e recebimentos de tratamentos dos pacientes.';

export const ROLE_ACCESS = [
  {
    key: 'CLINIC_ADMIN',
    fullAccess: true,
    description: 'Acesso total às telas da clínica.',
    extraAccess: [
      'Dashboard',
      'Financeiro (Dashboard, Entradas, Saídas)',
      'Tarefas',
      'Configurações (Gerais, Clínica, Impressões)',
      'Usuários e acessos',
    ],
  },
  {
    key: 'DENTIST',
    fullAccess: false,
    description:
      'Acesso apenas às telas base do sistema. Sem telas adicionais (financeiro, tarefas ou configurações).',
    extraAccess: [],
  },
  {
    key: 'FINANCIAL',
    fullAccess: false,
    description: 'Telas base, mais o módulo financeiro completo.',
    extraAccess: ['Financeiro (Dashboard, Entradas, Saídas)'],
  },
  {
    key: 'RECEPTIONIST',
    fullAccess: false,
    description: 'Telas base, gestão de tarefas e os alertas de tarefas na tela inicial.',
    extraAccess: ['Tarefas', 'Alertas de tarefas na Início'],
  },
];
